module.exports = __webpack_public_path__ + "static/streching-754c127d5674479c5c12d79e8e2650ed.svg";